/**
 * Optimistic cart count bump + badge pulse.
 * Drawer contents still come from server section HTML.
 */
(function () {
  const COUNT_SELECTOR = '.lilja-hd-cart-count';
  const ICON_SELECTOR = '#cart-icon-bubble';

  function readCount(el) {
    if (!el) return 0;
    const n = parseInt(el.textContent, 10);
    return Number.isFinite(n) ? n : 0;
  }

  function ensureCountEl(icon) {
    if (!icon) return null;
    let el = icon.querySelector(COUNT_SELECTOR);
    if (el) return el;
    el = document.createElement('span');
    el.className = 'lilja-hd-cart-count';
    el.setAttribute('aria-hidden', 'true');
    el.textContent = '0';
    icon.appendChild(el);
    return el;
  }

  window.LiljaCartFeedback = {
    /**
     * @param {number} delta units being added
     * @returns {{ revert: Function }}
     */
    optimisticAdd(delta) {
      const amount = Math.max(0, Number(delta) || 0);
      const icon = document.querySelector(ICON_SELECTOR);
      const countEl = ensureCountEl(icon);
      const previous = readCount(countEl);
      const next = previous + amount;

      if (countEl) {
        countEl.textContent = String(next);
        countEl.classList.remove('lilja-cart-count--pulse');
        // force reflow for restart
        void countEl.offsetWidth;
        countEl.classList.add('lilja-cart-count--pulse');
      }
      if (icon) {
        icon.classList.remove('lilja-cart-icon--pulse');
        void icon.offsetWidth;
        icon.classList.add('lilja-cart-icon--pulse');
      }

      return {
        revert() {
          if (!countEl) return;
          if (previous <= 0) {
            countEl.remove();
          } else {
            countEl.textContent = String(previous);
          }
        },
      };
    },
  };
})();
